import { ValueOf } from '../utilities/types';

const productTypes = {
  INVOICE: 'invoice',
  LINE_OF_BUSINESS: 'lineOfBusiness',
  SWISH: 'swish',
} as const;

export const productTypesChoices = [
  {
    id: productTypes.INVOICE,
    name: 'Invoice',
  },
  {
    id: productTypes.LINE_OF_BUSINESS,
    name: 'Line of business',
  },
  {
    id: productTypes.SWISH,
    name: 'Swish',
  },
];

export const relatedEntitiesTypes = [
  productTypes.LINE_OF_BUSINESS,
  productTypes.SWISH,
];

export type ProductTypes = ValueOf<typeof productTypes>;

export default productTypes;
